/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable class-methods-use-this */
import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import moment from 'moment';

import '../Overview.scss';
import iconArrow from '../../../../assets/images/drop_down_2.svg';
import iconCollect from '../../../../assets/images/ic_coleta_orange.svg';

import { BotsCreators } from '../../../../store/actions/bots';
import OverviewCard from '../../../../components/Builder/Overview/OverviewCard';

const INITIAL_COLLECT_SELECTED_DATA = {
  hidden: true,
  optionSelected: {},
};

const collectSelectOptions = [
  { title: '24 horas', value: moment().subtract(1, 'days') },
  { title: '7 dias', value: moment().subtract(7, 'days') },
  { title: '30 dias', value: moment().subtract(30, 'days') },
  // { title: '6 meses', value: moment().subtract(5, 'months') },
  // { title: '1 ano', value: moment().subtract(1, 'years') },
];

/**
 * Component for show extract data from the Collect Data OverviewCard
 *
 * @param {object} props Component needed data
 * @returns
 */
const BotCollectData = (props) => {
  const {
    i18n,
    bot,
    match,
    user,
    botCollectDataCount,
    resetBotCollectDataCount,
  } = props;
  const { botid: botId } = match.params;

  const [dataCollectSelected, setDataCollectSelected] = useState(
    INITIAL_COLLECT_SELECTED_DATA
  );
  const [showSensitivityData, setShowSensitivityData] = useState(false);
  const [collectDataCount, setCollectDataCount] = useState(0);
  const collectWrapperRef = useRef(null);

  /**
   * Add mouse click listener for close de dropdown menu
   */
  useEffect(() => {
    document.addEventListener('click', onClickOutsideComponent, false);
    return () => {
      resetBotCollectDataCount();
      document.removeEventListener('click', onClickOutsideComponent, false);
    };
  }, []);

  /**
   * Called when user value change and retrieve the collect data count value if the user has value
   */
  useEffect(() => {
    if (user) {
      const { getBotCollectDataCount } = props;
      const { dashboard_token: token } = user;
      const option = collectSelectOptions[1];
      const startDate = option.value;
      const endDate = moment().format();
      getBotCollectDataCount(botId, token, { startDate, endDate });
    }
  }, [user]);

  /**
   * Called when user select a option from period to extract collect data
   */
  useEffect(() => {
    callDownloadCollectDataFile();
  }, [dataCollectSelected.hidden]);

  /**
   * Set new data for OverviewCard value to show
   */
  useEffect(() => {
    if (botCollectDataCount.length > 0) {
      const { count } = botCollectDataCount[0];
      if (count) {
        setCollectDataCount(count);
      }
    }
  }, [botCollectDataCount]);

  /**
   * Call API to download the file with the collect data on filter selected
   */
  const callDownloadCollectDataFile = () => {
    if (dataCollectSelected.hidden) {
      const { title, value } = dataCollectSelected.optionSelected;

      if (user && title && value) {
        const { getBotCollectDataCsv } = props;
        const { dashboard_token: token } = user;
        const startDate =
          title === 'tudo' ? moment(bot.creationDate).format() : value.format();
        const endDate = moment().format();
        getBotCollectDataCsv(botId, token, showSensitivityData, {
          startDate,
          endDate,
        });
      }
    }
  };

  /**
   * Called when user click outside from the extract dropdown
   * @param {Object} event event from mouse
   */
  const onClickOutsideComponent = (event) => {
    if (
      collectWrapperRef.current &&
      !collectWrapperRef.current.contains(event.target)
    ) {
      const newDataCollectSelected = {
        ...dataCollectSelected,
        hidden: true,
      };
      setDataCollectSelected(newDataCollectSelected);
    }
  };

  /**
   * Called when the user click on extract button
   */
  const onClickCollectInput = () => {
    const newDataCollectSelected = {
      ...dataCollectSelected,
      hidden: !dataCollectSelected.hidden,
    };
    setDataCollectSelected(newDataCollectSelected);
  };

  /**
   * Called when user select a period option extract button dropdown
   * @param {Object} option selected period object value from dropdown
   */
  const onClickCollectOption = (option) => {
    const newOptionSelected = {
      hidden: !dataCollectSelected.hidden,
      optionSelected: option,
    };
    setDataCollectSelected(newOptionSelected);
  };

  /**
   * Função invocada quando é clicado no checkbox para mostrar ou não os dados sensíveis
   * invertendo o valor do state showSensitivityData
   */
  const onClickShowSensitivityData = (event) => {
    if (!event.target.value) {
      event.preventDefault();
    }
    setShowSensitivityData(!showSensitivityData);
  };

  const isAdminOrRoot = () =>
    user &&
    (user?.selectedCompany?.claim?.name === 'Admin' ||
      user?.selectedCompany?.claim?.name === 'Root');

  /**
   * Render the collect data period options to search
   */
  const renderCollectOptions = () => {
    const options = collectSelectOptions.map((option) => {
      return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div
          key={option.title}
          className="select-line"
          onClick={() => onClickCollectOption(option)}
        >
          <span>{i18n.t(option.title)}</span>
        </div>
      );
    });

    return options;
  };

  /**
   * Renderiza a opção para esconder ou não os dados sensíveis
   * caso o usuário logado tenha permissão para isso
   */
  const renderShowSensitivityDataButton = () => {
    if (!isAdminOrRoot()) {
      return false;
    }

    return (
      <label
        htmlFor="show-variables"
        className="collect-data-sensitivity"
        onClick={onClickShowSensitivityData}
      >
        <input
          id="show-variables"
          type="checkbox"
          name="show-variables"
          value={showSensitivityData}
          checked={showSensitivityData}
          onChange={onClickShowSensitivityData}
        />{' '}
        Exibir dados sensíveis
      </label>
    );
  };

  /**
   * Render collect data html element
   */
  const renderCollectData = () => {
    return (
      <div className="collect-data-container">
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div className="collect-select" ref={collectWrapperRef}>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
          <div
            className="collect-options"
            onClick={() => onClickCollectInput()}
          >
            <input
              id="collect-options-input"
              type="text"
              value="Extrair"
              disabled
            />
            <span>{i18n.t('Extrair')}</span>
            <img src={iconArrow} alt="" />
          </div>
          <div
            id="dropdown"
            className="dropdown"
            hidden={dataCollectSelected.hidden}
          >
            {renderCollectOptions()}
          </div>
        </div>
        {renderShowSensitivityDataButton()}
      </div>
    );
  };

  return (
    <OverviewCard
      icon={iconCollect}
      label={i18n.t('Dados Coletados')}
      count={collectDataCount}
      countColor="color-orange"
      renderData={renderCollectData}
      customDataStyle={{ marginLeft: 25 }}
      renderCustomDataStyle={isAdminOrRoot()}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    bot: state.bots.bot,
    botCollectDataCount: state.bots.botCollectDataCount,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(BotCollectData))
);
